import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import globals from '../../ea/globals.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import rte, { insert } from '../rte.js'
import array from '@mailobj-browser/front/js/utils/array.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    button
  ) => {
    const id = Math.random()
    const text = `<span eaid="draw${id}"></span>`
    const { ownerDocument } = button
    const form = one('form[name="send_valid"]', ownerDocument)
    const rte = one('iframe[data-rte]', form)

    if (rte && rte.id) {
      insert(rte.id, text)
      globals.ea_mail_submit(form, '', 'attach_draw_rte_' + id, 1)
    }
  }
})

export default button => {
  onClick.listen(button)
}
